import { z } from 'zod';
export const UPDATE_STEPS_TOTAL = 9;
export const UPDATE_CANCEL_LAST_STEP = 4;
export const MAX_LOCAL_UPLOAD_BYTES = 4 * 1024 * 1024 * 1024;
export const UPDATE_BROADCAST_LEAD_MINUTES = 10;
export const UPDATE_NOTICE_HOURS = 24;
export const SCHEDULE_UPDATE_MAX_DAYS = 30;
export const REQUIRED_UPDATE_DEADLINE_DAYS = 14;
export const REQUIRED_UPDATE_HOUR = 2;
export const REQUIRED_UPDATE_LOCK_HOUR = 9;
const plainVersion = z
    .string()
    .trim()
    .regex(/^\d+\.\d+\.\d+(-[0-9A-Za-z.]+)?$/, 'version must look like 3.4.0 or 3.4.0-beta.1');
export const scheduleUpdateSchema = z.object({
    version: plainVersion,
    at: z.string().datetime(),
});
export const UPDATE_RESTART_MINUTES = 3;
export function requiredByDefault(markedAt) {
    return new Date(markedAt.getTime() + REQUIRED_UPDATE_DEADLINE_DAYS * 24 * 60 * 60 * 1000);
}
export function updateNoticeText(at, formatTime) {
    return `The system restarts at ${formatTime(at)} for an update, about ${UPDATE_RESTART_MINUTES} minutes. Save your work.`;
}
//# sourceMappingURL=local-updates.js.map